import { render, staticRenderFns } from "./ContractSnapshotHistory.vue?vue&type=template&id=5058f8f2&scoped=true"
import script from "./ContractSnapshotHistory.vue?vue&type=script&lang=js"
export * from "./ContractSnapshotHistory.vue?vue&type=script&lang=js"
import style0 from "./ContractSnapshotHistory.vue?vue&type=style&index=0&id=5058f8f2&prod&lang=scss&scoped=true"
import style1 from "./ContractSnapshotHistory.vue?vue&type=style&index=1&id=5058f8f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5058f8f2",
  null
  
)

export default component.exports